/**
 * UpgradeModalContext — global upgrade modal trigger.
 * Wrap App with <UpgradeModalProvider> and call openUpgradeModal() from anywhere.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

export const UpgradeModalContext = createContext(null);

export function UpgradeModalProvider({ children }) {
  const [state, setState] = useState({ open: false, context: null });

  const openUpgradeModal = useCallback((ctx = {}) => {
    setState({ open: true, context: ctx });
  }, []);

  const closeUpgradeModal = useCallback(() => {
    setState({ open: false, context: null });
  }, []);

  return (
    <UpgradeModalContext.Provider value={{ openUpgradeModal, closeUpgradeModal, ...state }}>
      {children}
    </UpgradeModalContext.Provider>
  );
}

export function useUpgradeModal() {
  const ctx = useContext(UpgradeModalContext);
  if (!ctx) throw new Error('useUpgradeModal must be used inside UpgradeModalProvider');
  return ctx;
}
